import type ItineraryPackage from './ItineraryPackage';

export default abstract class ItineraryLateralLoader {
    abstract loadItineraries(params: any): Promise<ItineraryPackage[]>;
}
